import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import css from './HorseDealCreateAccountTeaser.css';
import { FormattedMessage } from 'react-intl';
import { SignupForm } from '../../forms';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Followers, NamedLink } from '../../components';
import { isLocalhost } from '../../util/urlHelpers';
import { signup } from '../../ducks/Auth.duck';
import { IconCheckCircleL, IconLockS } from '../../icons';
import { getDefaultList } from './getDefaultList';
import classNames from 'classnames';

const windowDefined = typeof window !== 'undefined';
const currentDate = new Date();
const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
const lastDayFormatted = lastDayOfMonth.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
});

const HorseDealCreateAccountTeaser = ({
    title,
    participationName,
    currentUser,
    address,
    bounds,
    origin,
    listingType,
    pub_activities,
    link,
    intl,
    signup,
    benefits,
    benefitsWrapperClassName,
    extraFields = {
        privateData: {
            registeredViaLandingPage: true,
        },
    },
}) => {
    const userIsDefined = currentUser && currentUser.id;

    const queryParams = [];
    const [userType, setUserType] = useState('rider');

    const handleSubmitDecorator = (values, callback) => {
        if (isLocalhost()) return callback(values);

        if (windowDefined && window.checkRecaptchaBeforeSubmit) {
            window.checkRecaptchaBeforeSubmit(() => callback(values));
        } else {
            callback(values);
        }
    };

    const handleUserTypeChange = event => {
        setUserType(event.target.value);
    };

    if (address) {
        queryParams.push(`address=${encodeURIComponent(address)}`);
    }

    queryParams.push(`bounds=${encodeURIComponent(bounds)}`);

    if (origin) {
        queryParams.push(`origin=${encodeURIComponent(origin)}`);
    }
    if (listingType) {
        queryParams.push(`listingType=${encodeURIComponent(listingType)}`);
    }
    if (pub_activities) {
        queryParams.push(
            `pub_activities=has_any%3A${encodeURIComponent(pub_activities.replace(',', '%2C'))}`
        );
    }

    const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

    const showSignupForm = !userIsDefined;
    const showLink = !showSignupForm && link;
    const showDefaultItem = !showSignupForm && !showLink;

    return (
        <div className={css.createAccountWrapper}>
            <div className={css.createAccountColumn}>
                <h2 className={css.createAccountTitle}>
                    <span className={css.createAccountTitleColor}>{title} </span>
                    {intl.formatMessage({ id: 'HorseDealCreateAccountTeaser.title' })}
                </h2>
                <div
                    className={classNames(css.benefitsWrapper, {
                        [benefitsWrapperClassName]: !!benefitsWrapperClassName,
                    })}
                >
                    {(benefits || getDefaultList({ participationName })).map(benefit => (
                        <div className={css.benefitsRow}>
                            {benefit.icon}
                            {benefit.text}
                        </div>
                    ))}
                </div>
                <Followers rootClassName={css.followersHolder}>
                    <p>
                        Sarah, Julia, David und 30’000 weitere sind bereits Teil unserer Community.
                    </p>
                </Followers>
            </div>
            <div className={css.createAccountColumn}>
                {showSignupForm && (
                    <div className={css.createAccountColumnContent}>
                        <div className={css.voucherNotification}>
                            <div className={css.voucherIcon}>
                                <IconCheckCircleL />
                            </div>
                            <div>
                                <p className={css.voucherTitle}>
                                    <FormattedMessage
                                        id="HorseDealCreateAccountTeaser.SectionRegister.voucherDetected"
                                        defaultMessage="Gutschein erkannt"
                                    />
                                </p>
                                <p className={css.voucherDescription}>
                                    <FormattedMessage
                                        id="HorseDealCreateAccountTeaser.SectionRegister.voucherText"
                                        defaultMessage={`Registriere dich bis zum {date} und erhalte einen CHF 10.- Gutschein von Reitsport.ch geschenkt.`}
                                        values={{
                                            date: lastDayFormatted,
                                        }}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className={css.userTypeRadio}>
                            <label className={css.radioLabel}>
                                <input
                                    type="radio"
                                    name="userType"
                                    value="rider"
                                    checked={userType === 'rider'}
                                    onChange={handleUserTypeChange}
                                    className={css.radioInput}
                                />
                                <FormattedMessage
                                    id="SignupSettings.userTypeRider"
                                    defaultMessage="Pferd finden"
                                />
                            </label>
                            <label className={css.radioLabel}>
                                <input
                                    type="radio"
                                    name="userType"
                                    value="horseowner"
                                    checked={userType === 'horseowner'}
                                    onChange={handleUserTypeChange}
                                    className={css.radioInput}
                                />
                                <FormattedMessage
                                    id="SignupSettings.userTypeHorseowner"
                                    defaultMessage="Pferdemensch finden"
                                />
                            </label>
                        </div>

                        <SignupForm
                            className={css.registrationForm}
                            initialValues={{ userType }}
                            onSubmit={values =>
                                handleSubmitDecorator(values, () => {
                                    const params = {
                                        ...values,
                                        firstName: values.fname,
                                        lastName: values.lname,
                                        ...extraFields,
                                        privateData: {
                                            ...values.privateData,
                                            ...(extraFields?.privateData || {}),
                                        },
                                    };

                                    signup(params);
                                })
                            }
                            bottomText={
                                <div className={css.sidenote}>
                                    <IconLockS />
                                    <p>Deine Daten sind bei uns sicher.</p>
                                </div>
                            }
                        />
                    </div>
                )}

                {showLink && (
                    <a href={link} className={css.subLinkPrimary}>
                        <FormattedMessage
                            id="SectionRegister.startButton"
                            defaultMessage="Los geht's!"
                        />
                    </a>
                )}

                {showDefaultItem && (
                    <NamedLink
                        className={css.subLinkPrimary}
                        name="SearchPage"
                        to={{ search: queryString }}
                    >
                        <FormattedMessage
                            id="SectionRegister.startButton"
                            defaultMessage="Los geht's!"
                        />
                    </NamedLink>
                )}
            </div>
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    signup: params => dispatch(signup(params)),
});

export default compose(injectIntl, connect(null, mapDispatchToProps))(HorseDealCreateAccountTeaser);
